module.exports = __webpack_public_path__ + "img/logox.dbb617c9.png";